export const rowSelected = (parameters) => {
  const { pallet_length } = parameters;
  if (pallet_length === '' || pallet_length === undefined) return null;

  let length = parseFloat(pallet_length);
  if (length < 0) return null;

  length = Math.ceil(length);
  return length - 1;
};

export const columnSelected = (parameters) => {
  const { pallet_width } = parameters;
  if (pallet_width === '' || pallet_width === undefined) return null;

  let width = parseFloat(pallet_width);
  if (width < 0) return null;

  width = Math.ceil(width);
  return width - 1;
};
